<template>
  <v-dialog
    :value="open"
    content-class="clipMove_dialog"
    @click:outside="handleOutside"
  >
    <v-btn
      icon
      class="clipMove_dialog-closeIcon"
      tabindex="-1"
      @click="$emit('onClose')"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="clipMove_dialog-title">
        <h1>{{ title }}</h1>
      </v-card-title>
      <v-divider />
      <v-card-text class="clipMove_dialog-text">
        <v-container class="clipMove_dialog-container">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <app-check2
                v-for="(item, i) in list"
                :key="i"
                no-border
                :value="selectedId === item.id"
                is-group
                class="clipMove_item"
                :class="{ 'clipMove_item--active': selectedId === item.id }"
                @input="handleCheck($event, item)"
              >
                {{ item.label }}</app-check2
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions class="clipMove_dialog-actions">
        <v-btn
          class="clipMove_dialog-btn clipMove_dialog-cancel"
          color="text"
          @click="handleClose"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="clipMove_dialog-btn clipMove_dialog-ok"
          color="primary"
          :loading="loading"
          @click="handleOk"
        >
          {{ okLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClipMoveDialog',
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => null,
    },
    list: {
      type: Array,
      default: () => [],
    },
    okLabel: {
      type: String,
      default: () => '変更',
    },
  },
  data() {
    return {
      selectedId: 0,
    };
  },
  watch: {
    open(val) {
      if (val) {
        this.selectedId = 0;
      }
    },
  },
  created() {
    this.selectedId = 0;
  },
  methods: {
    handleOutside(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('onClose');
    },
    handleCheck(event, item) {
      this.selectedId = item.id;
    },
    handleClose() {
      this.$emit('onClose');
    },
    async handleOk() {
      this.$emit('onOk', this.selectedId);
    },
  },
};
</script>

<style lang="scss">
.clipMove {
  .v-btn {
    margin-top: 10px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  .v-dialog > .v-card > .v-card__title {
    padding: 0;
  }
  &_item {
    .customCheck2_label {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    &--active {
      .customCheck2_label {
        font-weight: bold;
        color: #0075c2;
      }
    }
  }
  &_dialog {
    position: relative;
    border-radius: 10px;
    width: 395px;
    height: 256px;
    overflow-y: unset;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    .v-card {
      border-radius: 10px;
    }
    h3 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-bottom: 10px;
    }
    &-cancel {
      color: #666 !important;
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-closeIcon {
      &.v-btn {
        &.v-btn--icon.v-size--default {
          position: absolute;
          right: 3px;
          top: 3px;
          z-index: 1;
        }

        .v-icon {
          margin-right: 0;
          font-size: 20px;
          color: #999;
          font-weight: bold;
        }

        &:not(.v-btn--text):not(.v-btn--outlined):hover:before,
        &.theme--light:hover::before {
          opacity: 0;
        }
      }
    }
    &-container {
      padding: 0 !important;
      max-height: 120px;
      overflow: auto;
      .v-divider {
        border-color: #ccc;
      }
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
    &-actions {
      margin-top: 20px;
      &.v-card__actions {
        padding: 8px 0 !important;
      }
      .v-btn {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      }
    }
    &-text {
      padding: 0 !important;
      margin-top: 9px;
      .v-text-field .v-input__control .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
      }
    }
    &-title {
      margin-bottom: 20px;
      h1 {
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
      &.v-card__title {
        padding: 0 !important;
      }
    }
  }
}
</style>
